import React, { useEffect, useState } from "react";
import ShowChalan from "../Chalan/ShowChalan";
import { fetchchallans } from "../Chalan/ChalanList";
import { useNavigate } from "react-router-dom";
const MainChallans = () => {
  const [mainchallan, setmainchallan] = useState([]);
  useEffect(() => {
    const loadData = async () => {
      const data = await fetchchallans();

      setmainchallan(data);
      mainchallan.reverse();
    };
    loadData();
  }, []);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  // Calculate the index of the first and last items to display on the current page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  // Extract the subset of items to display on the current page
  const itemsToDisplay = Object.values(mainchallan)
    .reverse()
    .slice(indexOfFirstItem, indexOfLastItem)
    .map((item, index) => {
      return <ShowChalan key={index} challan={item[1]} />;
    });
  const navigate = useNavigate();

  return (
    <div className="ch-list-container" style={{ margin: "auto" }}>
      <h2 style={{ textAlign: "center" }}>Main Challan</h2>
      <div>
        {itemsToDisplay}
        <div style={{ textAlign: "center" }}>
          <button onClick={() => setCurrentPage(currentPage - 1)}>
            &laquo;
          </button>
          <button onClick={() => setCurrentPage(1)}>1</button>
          <button onClick={() => setCurrentPage(2)}>2</button>
          <button onClick={() => setCurrentPage(3)}>3</button>
          <button onClick={() => setCurrentPage(4)}>4</button>
          <button onClick={() => setCurrentPage(currentPage + 1)}>
            &raquo;
          </button>
        </div>
      </div>
      {/* {Object.values(mainchallan)
        .reverse()
        .map((item, index) => {
          console.log("index : ", index);
          return <ShowChalan key={index} challan={item[1]} />;
        })} */}
      <div style={{ textAlign: "center" }}>
        <button
          onClick={() => {
            navigate("/dashbaord/invoice");
          }}
        >
          Back
        </button>
      </div>
    </div>
  );
};

export default MainChallans;
